<div class="container-flex prompt-menu">
  <div>
    {{ autoCorrectedValue() }}
  </div>
  <div class="flex return-box">
    <mat-icon class="return-icon">keyboard_return</mat-icon>
  </div>
</div>
